'use client';

import * as React from 'react';
import {Typography} from '@purpose/ui/components/typography/typography';
import {cn} from '@purpose/ui/lib/utils';

type DiscountInfoProps = {
  type: string;
  amount?: string | number;
  category?: string | {id: number; name: string}[];
  percentage?: string;
  isPublic?: boolean;
  startDate?: string;
  endDate?: string;
};

interface DiscountInfoComponentProps extends DiscountInfoProps {
  t: (key: string) => string;
  className?: string;
}

const DiscountInfo = ({
  type,
  amount,
  percentage,
  category,
  t,
  className
}: DiscountInfoComponentProps) => {
  const formattedCategory =
    typeof category === 'string'
      ? category
      : category?.map(item => item.name).join(', ');

  return (
    <div
      className={cn(
        'flex w-full flex-row items-start justify-between py-[72px]',
        className
      )}
    >
      <div className="flex flex-col gap-3">
        <Typography variant="body1" className="font-semibold">
          {t('BenefitsPage.Create.Step4.DiscountType')}
        </Typography>
        <Typography variant="body1" className="font-semibold">
          {t('BenefitsPage.Create.Step4.DiscountAmount')}
        </Typography>
      </div>
      <div className="flex flex-col gap-3">
        <Typography variant="body1">{type}</Typography>
        <Typography variant="body1">
          {type === 'percentage' ? '-' : amount}
        </Typography>
      </div>
      <div className="flex w-1/2 flex-col gap-3">
        <div className="flex w-full flex-row">
          <Typography variant="body1" className="w-1/2 font-semibold">
            {t('BenefitsPage.Create.Step4.DiscountPercentage')}
          </Typography>
          <Typography variant="body1" className="w-1/2">
            {type === 'percentage' ? percentage : '-'}
          </Typography>
        </div>
        <div className="flex w-full flex-col gap-1">
          <Typography variant="body1" className="font-semibold">
            {t('BenefitsPage.Create.Step4.Category')}
          </Typography>
          <Typography variant="body1">{formattedCategory}</Typography>
        </div>
      </div>
    </div>
  );
};

export {DiscountInfo};
export type {DiscountInfoProps, DiscountInfoComponentProps};
